export default __webpack_public_path__ + "static/media/password.88c472a7.svg";